import { createContext, useContext } from 'react'

export type CacheValue = unknown
export type CacheData = Record<string, CacheValue>

export const CacheContext = createContext<{
  data: CacheData
  set: (key: string, value: CacheValue) => void
}>({
  data: {},
  set: () => void 0,
})

export function useMemoryCache<T>(key: string) {
  const { data, set } = useContext(CacheContext)
  return {
    data: data[key] as T,
    set: (value: T) => set(key, value),
  }
}
